import { useEffect, useState } from "react"
import { useNavigate, useParams, useSearchParams } from "react-router-dom"
import { Api } from "../../api/Assinafy"
import { Alert, Button, Form, Input } from "../../components"
import { Page, Section } from "../../layout"
import "./styles.scss"

const DocumentRelease = () => {
  const { document_id } = useParams()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const [email, setEmail] = useState("")
  const [formLoading, setFormLoading] = useState(false)
  const [formAlert, setFormAlert] = useState(null) 

  const isValidEmail = (v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)

  useEffect(() => {
    const fromUrl = searchParams.get("email")
    if (fromUrl && String(fromUrl).trim() !== "") {
      setEmail(String(fromUrl).trim())
    }
  }, [searchParams])

  const handleSubmit = (event) => {
    if (event?.preventDefault) {
      event.preventDefault()
    }

    if (!email) {
      setFormAlert({ type: "warning", message: "Por favor, informe o e-mail." })
      return
    }
    if (!isValidEmail(email.trim())) {
      setFormAlert({ type: "warning", message: "Informe um e-mail válido." })
      return
    }
    if (!document_id) {
      setFormAlert({ type: "danger", message: "Documento não encontrado na URL." })
      return
    }

    setFormLoading(true)
    setFormAlert(null)

    Api("publicDocument/sendToken")(document_id ,{
      recipient: email.trim(),
      channel: "email",
    })
      .then((resp) => {
        const httpStatus = Number(resp?.status)
        const apiStatus = Number(resp?.data?.status ?? resp?.status)
        const okHttp = [200, 201, 202, 204].includes(httpStatus)
        const okApi  = apiStatus === 200

        if (okHttp || okApi) {
          const qs = new URLSearchParams(searchParams)
          qs.set("channel", "email")
          qs.set("email", email.trim())
          qs.set("sent", "1")
          navigate(`/release/${document_id}?${qs.toString()}`, { replace: true })
          return
        }

        const msg = resp?.data?.message || "Não foi possível enviar o código. Tente novamente."
        setFormAlert({ type: "warning", message: msg })
      })
      .catch((err) => {
        const status = Number(err?.response?.status)
        const serverMsg = err?.response?.data?.message
        let message =
          serverMsg ||
          err?.message ||
          "Não foi possível enviar o código. Tente novamente."

        if (status === 404) {
          message =
            "O e-mail informado não está autorizado para acessar este documento ou o documento não foi encontrado."
        } else if (status === 400) {
          message = "Dados inválidos. Verifique o e-mail informado e tente novamente."
        } else if (status === 401 || status === 403) {
          message = "Acesso não autorizado para este destinatário."
        } else if (String(err?.code) === "ERR_NETWORK") {
          message = "Falha de conexão. Verifique sua internet e tente novamente."
        }

        setFormAlert({ type: "danger", message })
      })
      .finally(() => {
        setFormLoading(false)
      })
  }

  const handleEmailChange = (event) => {
    setEmail(event.target.value)
    if (formAlert) setFormAlert(null)
  }

  const isInvalid = formAlert?.type === "warning" || formAlert?.type === "danger"
  const sent = searchParams.get("sent") === "1"

  return (
    <Page className="page-sign page-document-release">
      <Section>
        <Section.Header
          title={sent ? "Pronto!" : "Liberação de Documento para Assinatura"}
          opening={sent ? "" : "Informe seu e-mail para receber o código de verificação."}
        />
        <div>
          {sent ? (
            <div className="document-release-sent">
              <p>
                Enviamos um e-mail para <a href={`mailto:${email}`}>{email}</a> com um código de ativação e um link.
              </p>
              <div className="form-help">
                Não recebi o código.{" "}
                <Button
                  variant="link"
                  className="btn-request"
                  onClick={handleSubmit}
                  loading={formLoading}
                  loadingText="Reenviando..."
                >
                  Reenviar
                </Button>
              </div>
            </div>
          ) : (
            <Form id="form-document-release" className="form-sign form-document-release" onSubmit={handleSubmit}>
              {formAlert?.message && (
                <Alert variant={formAlert.type} onClose={() => setFormAlert(null)}>
                  {formAlert.message}
                </Alert>
              )}

              <Form.Group>
                <Input.Email
                  name="email"
                  placeholder="E-mail"
                  value={email}
                  onChange={handleEmailChange}
                  required
                  className={isInvalid ? "is-invalid" : ""}
                />
              </Form.Group>
              <div className="document-release-info">
                Precisa ser o e-mail cadastrado para você no momento do envio do documento.
              </div>
              <Form.Footer>
                <Button variant="primary" submit loading={formLoading} className="btn-access-document">
                  ENVIAR CÓDIGO
                </Button>
              </Form.Footer>
            </Form>
          )}
        </div>
      </Section>
    </Page>
  )
}

export default DocumentRelease
